<template>
  <div class="physioParallelCombination" v-loading="loading">
    <div class="header">
      <div class="header_left">
        <el-button v-if="['', '0', 0].includes(deptId)" type="primary" icon="el-icon-plus" @click="toEdit()">新增</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        height="100%"
        :data="list">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column label="名称" prop="combinationName" min-width="220"></el-table-column>
        <el-table-column label="包含分类" prop="combinationDetails" min-width="260" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.combinationDetails.map(v => { return v.secondCategoryName }).join('、') }}
          </template>
        </el-table-column>
        <el-table-column label="操作员" prop="updateBy" min-width="120"></el-table-column>
        <el-table-column label="更新时间" prop="updateTime" min-width="160">
          <template slot-scope="scope">
            {{ new Date(scope.row.updateTime).Format('yyyy-MM-dd hh:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="['', '0', 0].includes(deptId)" type="primary" icon="el-icon-edit" @click="toEdit(scope.row.id)">编辑</el-button>
            <el-button v-if="['', '0', 0].includes(deptId)" type="danger" icon="el-icon-delete" @click="toDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="`${editMap.form.id ? '编辑' : '新增'}组合`"
      :visible.sync="editMap.visible"
      width="690px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="editDialogClose">
      <div class="dialog_content">
        <el-form ref="editForm" class="dialog_form" :model="editMap.form" :rules="editMap.rules" label-width="100px">
          <el-form-item label="组合名称：" prop="combinationName">
            <el-input class="dialog_form_input" v-model.trim="editMap.form.combinationName" maxlength="50" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="添加分类：" required>
            <el-cascader
              ref="categoryCascader"
              class="dialog_form_input"
              v-model="editMap.form.combinationSelect"
              :options="categoryList"
              @change="categoryChange">
            </el-cascader>
            <el-table
              class="dialog_form_table"
              :data="editMap.form.combinationDetails"
              max-height="310">
              <el-table-column type="index" label="序号" width="60"></el-table-column>
              <el-table-column label="小类" prop="secondCategoryName" min-width="150"></el-table-column>
              <el-table-column label="归属大类" prop="firstCategoryName" min-width="150"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="text" @click="categoryDelete(scope.row.secondCategoryId)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="editDialogClose">取 消</el-button>
        <el-button type="primary" @click="editDialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getPhysioCategoryList,
    getPhysioCombinationList,
    getPhysioCombinationById,
    postPhysioCombination,
    putPhysioCombination,
    deletePhysioCombination
  } from '@/api/physio'

  export default {
    name: "physioParallelCombination",
    data () {
      return {
        deptId: sessionStorage.getItem('deptId'),
        loading: false,
        categoryList: [],
        list: [],
        editMap: {
          visible: false,
          loading: false,
          rules: {
            combinationName: [{ required: true, message: '请输入组合名称', trigger: 'blur' }]
          },
          form: {
            id: '',
            combinationName: '',
            combinationSelect: [],
            combinationDetails: []
          }
        }
      }
    },
    created () {
      this.getCategoryList()
      this.getList()
    },
    methods: {
      async getCategoryList () {
        const res = await getPhysioCategoryList()
        if (res.code === 200) {
          let list = res.data.filter(v => v.level === 1).map(v => {
            return {
              label: v.physioLabel,
              value: v.id,
              children: []
            }
          })
          const secondList = res.data.filter(v => v.level === 2).map(v => {
            return {
              parentId: v.parentId,
              label: v.physioLabel,
              value: v.id
            }
          })
          secondList.forEach(second => {
            const first = list.find(v => v.value === second.parentId)
            if (first) {
              first.children.push({
                parentId: first.value,
                parentIdName: first.label,
                label: second.label,
                value: second.value
              })
            }
          })
          this.categoryList = list
        }
      },
      async getList () {
        this.loading = true
        const res = await getPhysioCombinationList()
        this.loading = false
        if (res.code === 200) {
          this.list = res.data
        }
      },
      async toEdit (id) {
        this.editMap.visible = true
        if (id) {
          this.editMap.loading = true
          const res = await getPhysioCombinationById({ combinationId: id })
          this.editMap.loading = false
          if (res.code === 200) {
            this.editMap.form.id = id || ''
            this.editMap.form.combinationName = res.data.combinationName || ''
            this.editMap.form.combinationDetails = res.data.combinationDetails || []
          }
        }
      },
      toDelete (id) {
        if (id) {
          this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            this.loading = true
            const res = await deletePhysioCombination({ combinationId: id })
            this.loading = false
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.getList()
            }
          }).catch(() => {})
        }
      },
      categoryChange () {
        const node = this.$refs['categoryCascader'].getCheckedNodes()[0]
        const info = {
          firstCategoryId: node.parent.value,
          firstCategoryName: node.parent.label,
          secondCategoryId: node.value,
          secondCategoryName: node.label
        }
        const isExist = this.editMap.form.combinationDetails.some(v => v.secondCategoryId === info.secondCategoryId)
        if (!isExist) {
          this.editMap.form.combinationDetails.push(info)
        } else {
          this.$message.error('该分类已添加')
        }
        this.editMap.form.combinationSelect = []
      },
      categoryDelete (secondCategoryId) {
        const index = this.editMap.form.combinationDetails.findIndex(v => v.secondCategoryId === secondCategoryId)
        if (index > -1) {
          this.editMap.form.combinationDetails.splice(index, 1)
        }
      },
      editDialogClose () {
        this.editMap.visible = false
        this.editMap.loading = false
        this.editMap.form.id = ''
        this.editMap.form.combinationName = ''
        this.editMap.form.combinationSelect = []
        this.editMap.form.combinationDetails = []
      },
      editDialogSubmit () {
        this.$refs['editForm'].validate(async valid => {
          if (valid) {
            if (this.editMap.form.combinationDetails.length === 0) {
              this.$message.error('请添加分类')
              return false
            }
            let res = null
            if (['', null, undefined].includes(this.editMap.form.id)) {
              res = await postPhysioCombination(this.editMap.form)
            } else {
              res = await putPhysioCombination(this.editMap.form)
            }
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.editDialogClose()
              this.getList()
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .physioParallelCombination {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .table {
    margin: 20px 0 0 0;
    width: 100%;
    height: calc(100% - 32px - 20px);
  }

  .physioParallelCombination /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .physioParallelCombination /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .physioParallelCombination /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .physioParallelCombination /deep/ .el-dialog__body {
    padding: 0;
  }

  .physioParallelCombination /deep/ .el-dialog__footer {
    padding: 12px 16px;
  }

  .dialog_content {
    padding: 20px 20px 0;
  }

  .dialog_form {
    overflow: hidden;
  }

  .dialog_form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #333333;
  }

  .dialog_form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .dialog_form_input {
    width: 100%;
  }

  .dialog_form_table {
    margin: 12px 0 0 0;
    width: 100%;
    border: 1px solid #EBEAEE;
  }
</style>